export const POINTS_TRANSLATION_KEY = 'points';
